module.exports = __webpack_public_path__ + "static/media/production-scheduling.e582c2af.jpg";